import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/Login'
import Register from '@/Register'
import PrivacyPolicy from '@/PrivacyPolicy'
import TermsOfUse from '@/TermsOfUse'
import ForgotPassword from '@/ForgotPassword'
import PasswordReset from '@/PasswordReset'
import Dashboard from '@/Dashboard'

import StatsView from '@/components/stats/View'

import NewsView from '@/components/news/View'
import NewsShow from '@/components/news/Show'
import NewsAdd from '@/components/news/Add'
import NewsEdit from '@/components/news/Edit'

import TicketsView from '@/components/tickets/View'
import TicketsShow from '@/components/tickets/Show'

import UsersView from '@/components/users/View'
import UsersShow from '@/components/users/Show'
import UsersAdd from '@/components/users/Add'
import UsersEdit from '@/components/users/Edit'

import CategoriesView from '@/components/categories/View'
import CategoriesShow from '@/components/categories/Show'
import CategoriesAdd from '@/components/categories/Add'
import CategoriesEdit from '@/components/categories/Edit'

import SentencesView from '@/components/sentences/View'
import SentencesShow from '@/components/sentences/Show'

import CommentsView from '@/components/comments/View'
import CommentsShow from '@/components/comments/Show'

import SchoolsView from '@/components/schools/View'
import SchoolsShow from '@/components/schools/Show'
import SchoolsAdd from '@/components/schools/Add'
import SchoolsEdit from '@/components/schools/Edit'

import LessonsView from '@/components/lessons/View'
import LessonsShow from '@/components/lessons/Show'
import LessonsAdd from '@/components/lessons/Add'
import LessonsEdit from '@/components/lessons/Edit'

import StudentsView from '@/components/students/View'
import StudentsShow from '@/components/students/Show'
import StudentsAdd from '@/components/students/Add'
import StudentsEdit from '@/components/students/Edit'

import SBLessonsView from '@/components/sb-lessons/View'
import SBLessonsShow from '@/components/sb-lessons/Show'
import SBLessonsAdd from '@/components/sb-lessons/Add'
import SBLessonsEdit from '@/components/sb-lessons/Edit'

import SBLessonChangesView from '@/components/sb-lesson-changes/View.vue'
import SBLessonChangesShow from '@/components/sb-lesson-changes/Show'

import UsersExportView from '@/components/user-export/View.vue'

//Premade section
import PremadeCategoriesView from '@/components/premade-categories/View'
import PremadeCategoriesShow from '@/components/premade-categories/Show'
import PremadeCategoriesAdd from '@/components/premade-categories/Add'
import PremadeCategoriesEdit from '@/components/premade-categories/Edit'

import PremadeSentencesView from '@/components/premade-sentences/View'
import PremadeSentencesShow from '@/components/premade-sentences/Show'
import PremadeSentencesAdd from '@/components/premade-sentences/Add'
import PremadeSentencesEdit from '@/components/premade-sentences/Edit'

import PremadeCommentsView from '@/components/premade-comments/View'
import PremadeCommentsShow from '@/components/premade-comments/Show'
import PremadeCommentsAdd from '@/components/premade-comments/Add'
import PremadeCommentsEdit from '@/components/premade-comments/Edit'

import MagicWordsView from '@/components/magic-words/View'
import MagicWordsShow from '@/components/magic-words/Show'
import MagicWordsAdd from '@/components/magic-words/Add'
import MagicWordsEdit from '@/components/magic-words/Edit'

Vue.use(Router)


const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login,
            meta: { requiresGuest: true }
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            meta: { requiresGuest: true }
        },
        {
            path: '/forgot/password',
            name: 'forgot-password',
            component: ForgotPassword,
            meta: { requiresGuest: true }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: PrivacyPolicy
        },
        {
            path: '/terms',
            name: 'terms',
            component: TermsOfUse
        },
        {
            path: '/password/reset/:token',
            name: 'password-reset',
            component: PasswordReset,
            meta: { requiresGuest: true }
        },
        {
            path: '/dashboard',
            component: Dashboard,
            meta: { requiresAuth: true },
            children: [
                {
                  path: '',
                  component: UsersView
                },
                {
                    path: 'stats',
                    component: StatsView
                },
                {
                    path: 'news',
                    component: NewsView
                },
                {
                    path: 'news/new',
                    name: 'add-news',
                    component: NewsAdd
                },
                {
                    path: 'news/:id',
                    name: 'news',
                    component: NewsShow
                },
                {
                    path: 'news/edit/:id',
                    name: 'news-edit',
                    component: NewsEdit
                },
                {
                    path: 'tickets',
                    component: TicketsView
                },
                {
                    path: 'tickets/:id',
                    name: 'ticket',
                    component: TicketsShow
                },
                {
                    path: 'users-export',
                    component: UsersExportView
                },
                {
                  path: 'users',
                  component: UsersView
                },
                {
                  path: 'users/new',
                  name: 'add-user',
                  component: UsersAdd
                },
                {
                  path: 'users/:id',
                  name: 'user',
                  component: UsersShow
                },
                {
                  path: 'users/edit/:id',
                  name: 'user-edit',
                  component: UsersEdit
                },

                //Start of Magic words
                {
                    path: 'magic-words',
                    component: MagicWordsView
                },
                {
                    path: 'magic-words/new',
                    name: 'add-magic-word',
                    component: MagicWordsAdd
                },
                {
                    path: 'magic-words/:id',
                    name: 'magic-word',
                    component: MagicWordsShow
                },
                {
                    path: 'magic-words/edit/:id',
                    name: 'magic-word-edit',
                    component: MagicWordsEdit
                },
                //End of Magic words

                {
                    path: 'categories',
                    component: CategoriesView
                },
                {
                    path: 'categories/new',
                    name: 'add-category',
                    component: CategoriesAdd
                },
                {
                    path: 'categories/:id',
                    name: 'category',
                    component: CategoriesShow
                },
                {
                    path: 'categories/edit/:id',
                    name: 'category-edit',
                    component: CategoriesEdit
                },
                {
                    path: 'sentences',
                    component: SentencesView
                },
                {
                    path: 'sentences/:id',
                    name: 'sentence',
                    component: SentencesShow
                },
                {
                    path: 'comments',
                    component: CommentsView
                },
                {
                    path: 'comments/:id',
                    name: 'comment',
                    component: CommentsShow
                },
                {
                    path: 'schools',
                    component: SchoolsView
                },
                {
                    path: 'schools/new',
                    name: 'add-school',
                    component: SchoolsAdd
                },
                {
                    path: 'schools/:id',
                    name: 'school',
                    component: SchoolsShow
                },
                {
                    path: 'schools/edit/:id',
                    name: 'school-edit',
                    component: SchoolsEdit
                },
                {
                    path: 'lessons',
                    component: LessonsView
                },
                {
                    path: 'lessons/new',
                    name: 'add-lesson',
                    component: LessonsAdd
                },
                {
                    path: 'lessons/:id',
                    name: 'lesson',
                    component: LessonsShow
                },
                {
                    path: 'lessons/edit/:id',
                    name: 'lesson-edit',
                    component: LessonsEdit
                },
                {
                    path: 'sb-lessons',
                    component: SBLessonsView
                },
                {
                    path: 'sb-lessons/new',
                    name: 'sb-add-lesson',
                    component: SBLessonsAdd
                },
                {
                    path: 'sb-lessons/:id',
                    name: 'sb-lesson',
                    component: SBLessonsShow
                },
                {
                    path: 'sb-lessons/edit/:id',
                    name: 'sb-lesson-edit',
                    component: SBLessonsEdit
                },
                {
                    path: 'sb-lesson-changes',
                    component: SBLessonChangesView
                },
                {
                    path: 'sb-lesson-changes/:lesson_id/:id',
                    name: 'sb-lesson-changes-show',
                    component: SBLessonChangesShow
                },
                {
                    path: 'students',
                    component: StudentsView
                },
                {
                    path: 'students/new',
                    name: 'add-student',
                    component: StudentsAdd
                },
                {
                    path: 'students/:id',
                    name: 'student',
                    component: StudentsShow
                },
                {
                    path: 'students/edit/:id',
                    name: 'student-edit',
                    component: StudentsEdit
                },
                //Premade section
                {
                    path: 'premade-categories',
                    component: PremadeCategoriesView
                },
                {
                    path: 'premade-categories/new',
                    name: 'add-premade-category',
                    component: PremadeCategoriesAdd
                },
                {
                    path: 'premade-categories/:id',
                    name: 'premade-category',
                    component: PremadeCategoriesShow
                },
                {
                    path: 'premade-categories/edit/:id',
                    name: 'premade-category-edit',
                    component: PremadeCategoriesEdit
                },
                //sentences
                {
                    path: 'premade-sentences',
                    component: PremadeSentencesView
                },
                {
                    path: 'premade-sentences/new',
                    name: 'add-premade-sentence',
                    component: PremadeSentencesAdd
                },
                {
                    path: 'premade-sentences/:id',
                    name: 'premade-sentence',
                    component: PremadeSentencesShow
                },
                {
                    path: 'premade-sentences/edit/:id',
                    name: 'premade-sentence-edit',
                    component: PremadeSentencesEdit
                },
                //comments
                {
                    path: 'premade-comments',
                    component: PremadeCommentsView
                },
                {
                    path: 'premade-comments/new',
                    name: 'add-premade-comment',
                    component: PremadeCommentsAdd
                },
                {
                    path: 'premade-comments/:id',
                    name: 'premade-comment',
                    component: PremadeCommentsShow
                },
                {
                    path: 'premade-comments/edit/:id',
                    name: 'premade-comment-edit',
                    component: PremadeCommentsEdit
                },
                {
                    path: 'privacy',
                    component: PrivacyPolicy
                },
                {
                    path: 'terms',
                    component: TermsOfUse
                },
            ]
        },
    ]
})

router.beforeEach(function (to, from, next) {	
	// prevent access to login & register once signed in...
	if (to.matched.some(record => record.meta.requiresGuest)
		&& window.auth.isAuthenticated())
	{
		next({ path: '/dashboard' });
	}
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// routes with meta.requiresAuth attr require user to be authorized
		// if not, redirect to /auth/signin...
		if (!window.auth.isAuthenticated()) {
			next({
				path: '/',
				query: { redirect: to.fullPath }
			})
		}
	}
	next() // make sure to always call next()!
});

export default router





// WEBPACK FOOTER //
// ./src/router/index.js